import type { Resource } from '../../';
export const search_box_title: Resource = {"default":"Search"};
